export default {
      id: "circle__a-point-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__a-point",
      toString: function () {
        return this.url;
      }
    }